import { FormConfig } from '../../../../components/Form';

export const METHODOLOGY_CONFIG: FormConfig = {
  description: {
    fieldType: 'richText',
    placeholder: 'Edit Methodology',
  },
};
